import connector from 'Utils/connector';
import { usageTrackReachedSectionEnd } from 'Webapp/shared/app/redux/actions/usage-actions';
import StoryboardLayout from 'Webapp/shared/app/themes/storyboard-layout/storyboard-layout';

export default connector({
  actions: {
    usageTrackReachedSectionEnd,
  },
})(StoryboardLayout);
